// Reports the active sidebar layout variant based on viewport width.
//   • "mobile"  — under 768px: sidebar lives behind a hamburger drawer
//   • "rail"    — 768–1023px (tablet): persistent icon rail, no hover-expand
//   • "desktop" — 1024px+ : persistent icon rail with hover-to-expand

import { useEffect, useState } from "react";

export type SidebarVariant = "mobile" | "rail" | "desktop";

const MOBILE_MAX = 767;
const DESKTOP_MIN = 1024;

function getVariant(width: number): SidebarVariant {
  if (width <= MOBILE_MAX) return "mobile";
  if (width >= DESKTOP_MIN) return "desktop";
  return "rail";
}

export function useSidebarBreakpoint(): SidebarVariant {
  const [variant, setVariant] = useState<SidebarVariant>(() => {
    if (typeof window === "undefined") return "desktop";
    return getVariant(window.innerWidth);
  });

  useEffect(() => {
    if (typeof window === "undefined") return;
    let frame = 0;
    const handle = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => setVariant(getVariant(window.innerWidth)));
    };
    window.addEventListener("resize", handle);
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener("resize", handle);
    };
  }, []);

  return variant;
}
